import React, { Component } from "react"
import MetaTags from 'react-meta-tags';

import { format } from 'date-fns';
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Breadcrumb,
  BreadcrumbItem,
  Spinner,
 
  

} from "reactstrap"
import CreatableSelect from 'react-select/creatable';
import {components} from 'react-select'
import Select from "react-select"
import axios from 'axios'
import  { Redirect } from 'react-router-dom'
// import $ from "jquery";
import { French } from "flatpickr/dist/l10n/fr.js";
import Flatpickr from "react-flatpickr"
import ReactSelect from 'react-select'
import makeAnimated from 'react-select/animated';
//import BootstrapSelect from "bootstrap-select"
import url from "../../common/api"
import {getLanguageList} from "../../services/langueService.js"
import {getThematiqueList} from "../../services/thematiqueService.js"
import ModalMessage from "../pages/messages/ModalMessage"
import {getUniteAdministrativeList} from "../../services/uniteAdministrativeService.js"
import {getQueries} from "../../queries/getQueries.js";
import {postQueries} from "../../queries/postQueries.js"
import {getTypeSystemeIrrigueList} from "../../services/systemeIrrigueService.js"
import {getTypeEvenementList} from "../../services/typeEvenementService.js"
import {getPaysList} from "../../services/paysService.js"
import {getStructureList} from "../../services/structureService.js"
import {getCategorieList} from "../../services/categorieService.js"
import {updateEvenement,removeElements,removeElement} from "../../services/evenementService.js"
import {addMotCle,getMotCleList} from "../../services/motCleService.js"
import Confirmer from "pages/Dashboard/Confirmer";
import {deleteQueries} from "../../queries/deleteQueries.js";

const Menu = props => {
  const optionSelectedLength = props.getValue().length || 0;
  return (
    <components.Menu {...props}>
      {optionSelectedLength < 5 ? (
        props.children
      ) : (
        <div style={{ margin: 15 }}>Vous avez atteint le nombre maximum de mot-clés</div>
      )}
    </components.Menu>
  );
};


class DetailEvenement extends Component {

  constructor(props) {
    super(props)

    this.state = { ok:"",evenement:{},systeme:[],unite:[],langue:[],thematique:[],
    mot:[],video:"",image:[],pjointe:[],localite:[],acces:[],profile:[],localisations:[],remove_data:{},
    type_evenements:[],event:"",checkSysteme:[],checkLocalisation:[],checkAcces:[],langues:[],irrigues:[],systeme_data:[],checkUnite:[],
    unites:[],unite_data:[],thematiques:[],thematique_data:[],checkThematique:[],chargement:false,hide:"none",
    motCles_attributes:[],
    validate_update:false,
    chargement_data:false, 
    accept_update:true,
    date_debut:"",date_fin:"",heureDebut:"",heureFin:"",
    type:props.type, index:props.index,public_id:0,
    show:false,
    success:true, 
    message:"Evènement modifié avec succès !",
    titre:"Message modification d'évènement", 
    boutton:"OK",
    profile_user:JSON.parse(sessionStorage.getItem("profileAuthAshia")),
   
     }
     this.handleCheckSysteme.bind(this)
     this.handleCheckUnite.bind(this)
     this.handleCheckThematique.bind(this)
     this.handleCheckLangue.bind(this)
     this.handleCheckLocalisation.bind(this)

     this.handleDeleteLocalisation.bind(this)
     this.handleDeleteLangue.bind(this)
     this.handleChangeMotCle.bind(this);

     this.handleDeleteThematique.bind(this)
     this.handleDeleteSysteme.bind(this)
     this.handleDeleteUnite.bind(this)
     this.handleDeleteProfile.bind(this)
  }



  handleDroit=()=>{
  
   //Type evenement
   $("#show-type-evenement").css("display","none")
   $("#valideRessource").css("display","none")
   $("#show-ok-te").css("display","none")

   //Tableaux

   $("#debut").css("display","none")
   $("#fin").css("display","none")

   $("#heure_debut").css("display","none")
   $("#heure_fin").css("display","none")

   $("#typesystemeirrigation").css("display","none")
   $("#thematique").css("display","none")
   $("#langue").css("display","none")
   $("#motcle").css("display","none")
   $("#localisation").css("display","none")
   $("#profile").css("display","none")
   $("#uniteadministrative").css("display","none")

   $("#show-tsi").css("display","none")
   $("#show-thematique").css("display","none")
   $("#show-ua").css("display","none")
  }

  componentDidMount(){
  

    this.handleCharge()
 

    var id=sessionStorage.getItem("idEvenement")
 
    // this.handleChargeSysteme()
    // this.handleChargeThematique()
    // this.handleChargeUnite()
   

    
    getMotCleList().then(e=>this.setState({motcle:e}))
    this.getData()

    getQueries("profiles").then(e=>{
      const data=e
      try{
        this.setState({public_id:data.filter(x => (x.libelle).toLowerCase() === ("Public").toLowerCase())[0].id,
        profiles_attributes:[{"profile_id":data.filter(x => (x.libelle).toLowerCase() === ("Public").toLowerCase())[0].id}]
      })
        
       }catch(error){
  
       }
 
       data.filter(x => (x.libelle).toLowerCase() != ("Public").toLowerCase()).map((element,idx) =>{
        this.setState({profile:[...this.state.profile,{value:element.id,label:element.libelle}]})
      })
 
    })
  }

  getData=()=>{
    //this.setState({chargement:false})
    var id=sessionStorage.getItem("idEvenement")

    fetch(url+"evenements/"+id)
    .then((response) => response.json())
    .then((data) => {
      this.setState({chargement:true})
      this.setState({evenement:data})
      console.log("la ressource:",data)
      this.setState({systeme:data.type_systeme_irrigues,
        heureDebut:data.heure_debut,heureFin:data.heure_fin,
        date_debut:data.date_debut,date_fin:data.date_fin,idEvenement:data.id})
      this.setState({unite:data.unite_administratives})
      this.setState({thematique:data.thematiques})
      this.setState({acces:data.profiles})
      this.setState({localite:data.pays})
      this.setState({langue:data.langues})
      this.setState({motcle:data.mot_cles})
      this.handleDroit()

      if(this.state.index===true){
          $("#droit_d").hide()
          $("#droit").hide()
      }
      
      $("#libelle").val(data.libelle)
      $("#url").val(data.url)
      $("#description").val(data.description)
      $("#lieu").val(data.lieu)
      $("#objectif").val(data.objectif)
      $("#cible").val(data.cible)
      $("#organisateur").val(data.organisateur)
      $("#date_debut").val(new Date(data.date_debut).toLocaleDateString())
      $("#date_fin").val(new Date(data.date_fin).toLocaleDateString())

      $("#h_debut").val(data.heure_debut)
      $("#h_fin").val(data.heure_fin)
     // this.setState({chargement:true})
   
      try{
          $("#type_evenement").val(data.type_evenement.libelle)
          this.setState({event:data.type_evenement.libelle})
         }catch(e){
 
         }
    })

  }

  handleRetour=()=>{
    if(this.state.index===true){
      $('#block_detail_ressource').hide()
      $('#acceuil-link').show()
      $('#block_page_acceuil').show()
      return 
  }else{
    this.setState({ok: <Redirect to='/liste-calendar'  />});
  return
  }
     
  }

  handleChangeMotCle=(e)=>{
    this.setState({motCles_attributes:[]})
    try{
      e.map((element,idx) =>{
        this.setState({motCles_attributes:[...this.state.motCles_attributes,{"mot_cle_id":element.value}]})
      })
    }catch(error){
      
    }
  }


  patch=(data)=>{
    var id=sessionStorage.getItem("idEvenement")

    const requestOptions = {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json','Accept': 'application/json' },
        body: JSON.stringify(data)
    };

      fetch(url+"evenements/"+id, requestOptions)
      .then((response) => response.json())
      .then(response =>{console.log("ok,",response)
      this.getData()
    
    } ,
    (error) => {
      
    })
  }


//charge


// delete
handleDeleteProfile=(id)=>{

  this.setState({validate_update:true})

  var data={"evenement_id":this.state.idEvenement,"profile_id":id}
 
  if(this.state.acces.length>=2){
    this.setState({acces:this.state.acces.filter((data)=>data.id!==id)})
    try{
      this.state.remove_data["evenement_profile/delete"].push(data)
      this.setState({remove_data:this.state.remove_data})
    }catch(err){
      this.state.remove_data["evenement_profile/delete"]=[]
      this.state.remove_data["evenement_profile/delete"].push(data)
      this.setState({remove_data:this.state.remove_data})
    }
    
    // removeElement(data,"ressource_profile/delete").then(data=>{
    
    // })
  }else{
    this.setState({message:"Tous les profils ne peuvent être supprimés !"})
    this.setState({show:true,success:false});
  }
 
}
handleDeleteLangue=(id)=>{

  this.setState({validate_update:true}) 

    var data={"evenement_id":this.state.idEvenement,"langue_id":id}

    try{
      this.state.remove_data["evenement_langue/delete"].push(data)
      this.setState({remove_data:this.state.remove_data})
    }catch(err){
      this.state.remove_data["evenement_langue/delete"]=[]
      this.state.remove_data["evenement_langue/delete"].push(data)
      this.setState({remove_data:this.state.remove_data})
    }
    
    // removeElement(data,"ressource_langue/delete").then(data=>{
      
    // })
   this.setState({langue:this.state.langue.filter((data)=>data.id!==id)})
}
handleDeleteUnite=(id)=>{

  this.setState({validate_update:true})

    var data={"evenement_id":this.state.idEvenement,"unite_administrative_id":id}

    try{
      this.state.remove_data["evenement_unite_administrative/delete"].push(data)
      this.setState({remove_data:this.state.remove_data})
    }catch(err){
      this.state.remove_data["evenement_unite_administrative/delete"]=[]
      this.state.remove_data["evenement_unite_administrative/delete"].push(data)
      this.setState({remove_data:this.state.remove_data})
    }

    // removeElement(data,"ressource_unite_administrative/delete").then(data=>{
      
    // })

    this.setState({unite:this.state.unite.filter((data)=>data.id!==id)})
  }

  handleDeleteThematique=(id)=>{
    this.setState({validate_update:true})
    var data={"evenement_id":this.state.idEvenement,"thematique_id":id}
    try{
      this.state.remove_data["evenement_thematique/delete"].push(data)
      this.setState({remove_data:this.state.remove_data})
    }catch(err){
      this.state.remove_data["evenement_thematique/delete"]=[]
      this.state.remove_data["evenement_thematique/delete"].push(data)
      this.setState({remove_data:this.state.remove_data})
    }
      
      // removeElement(data,"ressource_thematique/delete").then(data=>{
      
      // })
      this.setState({thematique:this.state.thematique.filter((data)=>data.id!==id)})
  }


handleDeleteSysteme=(id)=>{

  this.setState({validate_update:true})

  var data={"evenement_id":this.state.idEvenement,"type_systeme_irrigue_id":id}

  try{
    this.state.remove_data["evenement_systeme_irrigue/delete"].push(data)
    this.setState({remove_data:this.state.remove_data})
  }catch(err){
    this.state.remove_data["evenement_systeme_irrigue/delete"]=[]
    this.state.remove_data["evenement_systeme_irrigue/delete"].push(data)
    this.setState({remove_data:this.state.remove_data})
  }
 
  // removeElement(data,"ressource_systeme_irrigue/delete").then(data=>{
    
  // })
  this.setState({systeme:this.state.systeme.filter((data)=>data.id!==id)})
}

handleDeleteLocalisation=(id)=>{

  this.setState({validate_update:true})

    var data={"evenement_id":this.state.idEvenement,"pay_id":id}
    try{
      this.state.remove_data["evenement_pay/delete"].push(data)
      this.setState({remove_data:this.state.remove_data})
    }catch(err){
      this.state.remove_data["evenement_pay/delete"]=[]
      this.state.remove_data["evenement_pay/delete"].push(data)
      this.setState({remove_data:this.state.remove_data})
    }
  
      // removeElement(data,"ressource_pay/delete").then(data=>{
      
      // })
      this.setState({localite:this.state.localite.filter((data)=>data.id!==id)})

      //suprime unite admininstratives
      this.state.unite.map((el,idx)=>{
        const unite={"evenement_id":this.state.idEvenement,"unite_administrative_id":el.id}

        try{
          this.state.remove_data["evenement_unite_administrative/delete"].push(unite)
          this.setState({remove_data:this.state.remove_data})
        }catch(err){
          this.state.remove_data["evenement_unite_administrative/delete"]=[]
          this.state.remove_data["evenement_unite_administrative/delete"].push(unite)
          this.setState({remove_data:this.state.remove_data})
        }

        // removeElement(unite,"ressource_unite_administrative/delete").then(data=>{
          
        // })

        this.setState({unite:this.state.unite.filter((data)=>data.id!==id)})
      })

     
  }


  handleDeleteActions=()=>{
      
    Object.keys(this.state.remove_data).map((element,idx)=>{
      removeElements(this.state.remove_data[element],element).then(data=>{
      
      })
    })
  }






handleChargeData=()=>{

  getLanguageList().then(e=>
   { 
    let langue1 = this.state.langue.map(val => { return val.id});
 
    let langue2 = e?.filter(itemX => !langue1.includes(itemX.value));
   
    this.setState({langues:langue2})
  }
    )

  // getUniteAdministrativeList().then(e=>
  //   {
  //     let pay1 = this.state.unite.map(val => { return val.id});
 
  //     let pay2 = e?.filter(itemX => !pay1.includes(itemX.value));

  //     this.setState({unites:pay2})
  //   })

  getTypeSystemeIrrigueList().then(e=>
    {
      let auteur1 = this.state.systeme.map(val => { return val.id});
  
 
   
     let auteur2 = e?.filter(itemX => !auteur1.includes(itemX.value));

 

     this.setState({irrigues:auteur2})
  })

  getThematiqueList().then(e=>{
    let auteur1 = this.state.thematique.map(val => { return val.id});
 
    let auteur2 = e?.filter(itemX => !auteur1.includes(itemX.value));
   
    this.setState({thematiques:auteur2})
  })

  getTypeEvenementList().then(e=>
    {
      this.setState({type_evenements:e})
  })

  getPaysList().then(e=>
    {
      let auteur1 = this.state.localite.map(val => { return val.id});
 
      let auteur2 = e?.filter(itemX => !auteur1.includes(itemX.value));
    
      this.setState({localisations:auteur2})
  })
}


//check
handleCheckSysteme=(data)=>{
  var  tab=[]
  this.setState({checkSysteme:tab,validate_update:true})
  try{
      data.map((val,idx)=>{
          this.setState({checkSysteme:[...this.state.checkSysteme,{type_systeme_irrigue_id:val.value}]})
      })

  }catch(error){
      
  }

  }

  handleCheckLangue=(data)=>{
    var  tab=[]
    this.setState({checkLangue:tab,validate_update:true})
    console.log("langue",data)
    try{
        data.map((val,idx)=>{
            this.setState({checkLangue:[...this.state.checkLangue,{langue_id:val.value}]})
        })

    }catch(error){
      this.setState({checkLangue:[]})
    }
    
  }

  handleCheckUnite=(data)=>{
    var  tab=[]
    this.setState({checkUnite:tab,validate_update:true})
    try{

        data.map((val,idx)=>{
            this.setState({checkUnite:[...this.state.checkUnite,{unite_administrative_id:val.value}]})
        })

    }catch(error){
        
    }
    
    }
    handleCheckLocalisation=(data)=>{
      var  tab=[]
      var unite=[]
      this.setState({checkLocalisation:tab,unites:[],validate_update:true})
      try{
        data.map((val,idx)=>{
  
          val.unite_administratives.map((el)=>{
            unite=[...unite,{value:el.id,label:el.libelle}]
            this.setState({unites:unite})
          })
  
  
          this.setState({checkLocalisation:[...this.state.checkLocalisation,{pay_id:val.value}]})
        })
      }catch(error){   
        this.setState({checkLocalisation:[],unites:[]})
      }
    }

    handleCheckThematique=(data)=>{
      var  tab=[]
      this.setState({checkThematique:tab,validate_update:true})
  
      try{
         
          data.map((val,idx)=>{
              this.setState({checkThematique:[...this.state.checkThematique,{thematique_id:val.value}]})
          })
  
      }catch(error){
          
      }
     
      }

  handleChangeAcces = () => {
    this.setState({validate_update:true})
    if($("#acces option:selected").val()=="Privé"){
        $("#profiles").show()
    }else{
      $("#profiles").hide()
      this.setState({checkAcces:[{"profile_id":this.state.public_id}]})
    }
  }

  handleChangeProfile = (e) => {
    var data=[]
    this.setState({checkAcces:data,validate_update:true})
    console.log("===>>",e)
    try{
      e.map((element,idx) =>{
        this.setState({checkAcces:[...this.state.checkAcces.filter(x => x.profile_id != this.state.public_id),{"profile_id":element.value}]})
        console.log("===>>profile",element)
      })

    }catch(e){
      this.setState({checkAcces:data})
    }


  }  

handleUpdateSysteme=()=>{
     
  this.patch({"evenement_systeme_irrigues_attributes":this.state.checkSysteme})
  $("#typesystemeirrigation").hide()
  $("#no-show-tsi").show()
  $("#show-tsi").hide()
}
  handleUpdateUnite=()=>{
      
    this.patch({"evenement_unite_administratives_attributes":this.state.checkUnite})
    
  
    $("#uniteadministrative").hide()
    $("#no-show-ua").show()
    $("#show-ua").hide()
  }
  handleUpdateThematique=()=>{
    this.patch({"evenement_thematiques_attributes":this.state.checkThematique})

    $("#thematique").hide()
    $("#no-show-thematique").show()
    $("#show-thematique").hide()
  } 

  handleCharge=()=>{}


  handleModifierEvenement=()=>{
     
   this.setState({chargement_data:true})

   // supprimer les elements concernés
   this.handleDeleteActions()

   var event={
     
     "libelle": $("#libelle").val(),
     "date_debut": this.state.date_debut,
     "date_fin":this.state.date_fin,
     "heure_debut": this.state.heureDebut,
     "heure_fin":this.state.heureFin,
     "description": $("#description").val(),
     "url": $("#url").val(),
     "organisateur":$("#organisateur").val(),
     "lieu":$("#lieu").val(),
     "objectif":$("#objectif").val(),
     "cible":$("#cible").val(),
     "type_evenement_id":$("#type_evenement_id option:selected").val(),
     "evenement_langues_attributes":_.uniqBy(this.state.checkLangue, 'langue_id'),
     "evenement_thematiques_attributes":_.uniqBy(this.state.checkThematique, 'thematique_id'),
     "evenement_systeme_irrigues_attributes":_.uniqBy(this.state.checkSysteme, 'type_systeme_irrigue_id'),
     "evenement_pays_attributes":_.uniqBy(this.state.checkLocalisation, 'pay_id'),
     "evenement_unite_administratives_attributes":_.uniqBy(this.state.checkUnite,"unite_administrative_id"),
     "evenement_profiles_attributes":_.uniqBy(this.state.checkAcces, 'profile_id'),

   }

   if($("#show-type-evenement option:selected").val()!=="0"){
    event["type_evenement_id"]=$("#show-type-evenement option:selected").val()
   }

  



   //update ressource width image
 
   updateEvenement(event).then(data=>{
     this.setState({message:"L'évènement a été modifiée avec succès !",chargement_data:false})
     this.setState({show:true,success:true});
     setTimeout(()=>
       window.location.reload(false)
     , 3000)
     //this.getData()
   })
 
}

handleChangeText=()=>{
  this.setState({validate_update:true})
}



handleValidate=()=>{
  this.setState({show:false})
  if(this.state.success){
    setTimeout(()=>
    window.location.reload(false)
  , 3000)
  }
  
}

  handleModifierEvent=()=>{
    this.setState({accept_update:false})
     
    this.handleChargeData()

    $(".owener-close").hide()
    $("#droit").hide()
    $("#droit_d").hide()

    setTimeout(()=>
    {
      this.setState({accept_update:true})
      $(".owener").show()
      $(".show").show()
      this.setState({hide2:"none"})
      this.setState({hide:"block"})

      document.getElementById("libelle").readOnly = false;
      document.getElementById("organisateur").readOnly = false;
      document.getElementById("description").readOnly = false;
      document.getElementById("cible").readOnly = false;
      document.getElementById("objectif").readOnly = false;
      document.getElementById("lieu").readOnly = false;
      document.getElementById("url").readOnly = false;
    }
  , 3000)

 
    
  }  

  handleAnuler=()=>{
    this.setState({validate_update:false,
      accept_update:true,
      checkSysteme:[],
      checkThematique:[],
      checkUnite:[],
      checkLangue:[],
      checkLocalisation:[],
      checkMot:[],
      checkNewAuteur:[],
      checkSousTypeRessource:[],
      checkNewMot:[],
      checkAcces:[],
      hide:"none",
      remove_data:{}})
    // this.handleChargeAll()
    this.getData()
    $(".owener-close").show()
    $("#droit").show()
    $("#droit_d").show()
    $("#droit_d").show()
    $(".owener").hide()
    $(".show").hide()
    document.getElementById("libelle").readOnly = true;
    document.getElementById("organisateur").readOnly = true;
    document.getElementById("description").readOnly = true;
    document.getElementById("cible").readOnly = true;
    document.getElementById("objectif").readOnly = true;
    document.getElementById("lieu").readOnly = true;
    document.getElementById("url").readOnly = true;
  }

  
  handleValiderSuppression=()=>{
    document.getElementById("cls").click()
    const id=sessionStorage.getItem("idEvenement")
    deleteQueries("evenements/"+id).then(data=>{
      
    this.setState({ok: <Redirect to='/liste-calendar'  />});

      // this.setState({message:"Acteur supprimé avec succès!!",title:"Suppression d'acteur"})
      // this.setState({show:true,success:true});
    })
  }
  
  handleConfirme=()=>{
    document.getElementById("modale").click()
  }


 render() {

  const animatedComponents = makeAnimated();
  const { pick } = this.state
  var today = new Date();
  const dataTest = [
    {
      value: 1, 
      label:"Test 1"
    },
    {
      value:2, 
      label:"Test 2"
    },
    {
      value:3, 
      label:"Test 3"
    }
  ];

  const isValidNewOption = (inputValue, selectValue) => inputValue.length > 0 && selectValue.length < 5;

  return (
          <React.Fragment>
          {
            (this.state.chargement)?
                (<>
              
            <div className="page-content">
            
               {this.state.ok}

               <ModalMessage
                show={this.state.show}
                success={this.state.success}
                boutton={this.state.boutton}
                handleValidate={this.handleValidate}
                message={this.state.message}
                titre={this.state.titre}
                onCloseClick={() => this.setState({ show: false })}
             />
              <Confirmer
                bouton="Supprimer"
                titre="Suppression d'évènement"
                message="Voullez-vous vraiment supprimer l'évènement?"
                handleValider={this.handleValiderSuppression}
            />

            <MetaTags>
                <title>Détails de l'évenement</title>
            </MetaTags>
            <Container fluid={true}>
            <Row>
            {!this.state.validate_update?
                  <Col md="4">
                    <Button onClick={this.handleRetour} style={{backgroundColor:"#6A7172",float:"left",borderRadius:"10px"}} >
                      Retour
                    </Button>
                  </Col>:null
                }

                 {this.state.profile_user?.droit_evenement?.modifier?
                <Col md="8">
                  {this.state.profile_user?.droit_expert?.supprimer?
                    <div id="droit_d" style={{marginRight:"10px"}}>
                      <Button onClick={this.handleConfirme} className="btn btn-danger" style={{ borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                          Supprimer l'évenement
                      </Button>
                    </div>:null
                    }
                  <div id="droit">
                  <Button onClick={this.handleModifierEvent} style={{ marginRight:"5px" ,backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                      Modifier l'évenement
                    </Button>
                  </div>
                  {
                    !this.state.accept_update?
                    <Button  style={{width:"150px",backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true">...</span>
                   
                 </Button>:null
                   }
                  </Col>:null
                  }
                  
                  
                </Row>
                {this.state.validate_update?
                <Row>
                  <Col md="6">
                  <Button onClick={this.handleRetour} style={{backgroundColor:"#6A7172",float:"left",borderRadius:"10px"}} >
                      Retour
                    </Button>
                  </Col>
                  <Col md="6" >
                  
                    
                    {
                    this.state.chargement_data?
                    <Button id="chargement" style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
                    </Button>:
                    <Button id="initial" onClick={this.handleModifierEvenement} style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                       Appliquer la modification
                    </Button>
                    }

                    
                  </Col>
                </Row>:null
                  }
             
                {/* <Row>
                  <Col md="8">
                      <div className="page-title-box d-flex align-items-center justify-content-between">
                      <h4 className="mb-0 font-size-18">Détails de l'évenement</h4>
                      </div>
                  </Col>
                </Row> */}
     
                <hr/>

                <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                  <CardBody>

                  {/* <Row>
                    <Col md="6">
                      <Button onClick={this.handleRetour} style={{backgroundColor:"#6A7172",float:"left",borderRadius:"10px"}} >
                        Retour
                      </Button>
                    </Col>
                    <Col md="6" id="droit">
                      <Button onClick={this.handleModifierEvenement} style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  color="success">
                        Modifier l'évenement
                      </Button>
                    </Col>
                  </Row>
                  <hr/> */}

                  <h4 className="text-center mt-2">Description de l'évenement</h4>
                  <hr/>

                  <Row className="mt-4"> 
                    <Col md="12">
                      <label>Libellé</label>
                      <Input
                        className="form-control"
                        type="text"
                        id="libelle"
                        onChange={this.handleChangeText}
                        readOnly
                      />
                    </Col>

                    {/* <Col md="4">
                     <label >Organisateur</label>
                      <Input
                        className="form-control"
                        type="text"
                        id="organisateur"
                        onChange={this.handleChangeText}
                        readOnly
                      />
                    </Col> */}
                  </Row>


                  <Row className="mt-4"> 
                    {/* <Col md="8">
                    <label>Objectif</label>
                     
                      <textarea
                        className="form-control"
                        onChange={this.handleChangeText}
                        id="objectif"
                     
                        readOnly
                      />
                    </Col> */}

                    <Col md="6">
                      <label>Types D'évenement</label>
                      <Input
                        className="form-control owener-close"
                        type="text"
                        id="type_evenement"
                        readOnly
                      />
                      <select  onChange={this.handleChangeText} className="form-select show" aria-label="Default select example" id="show-type-evenement">
                      {
                        this.state.type_evenements.map(
                          (element,idx) =>(
                            element.label===$("#type_evenement").val()?
                            <option value={element.value} selected>{$("#type_evenement").val()}</option>:
                            <option value={element.value}>{element.label}</option>
                          )
                        )
                      }
                      </select>
                    </Col>

                    
                    <Col md="6">
                     <label >Organisateur</label>
                      <Input
                        className="form-control"
                        type="text"
                        id="organisateur"
                        onChange={this.handleChangeText}
                        readOnly
                      />
                    </Col>
                  </Row>

                  <Row className="mt-4"> 
                    <Col md="6">
                    <label >Cible</label>
                      <Input
                        className="form-control"
                        type="text"
                        id="cible"
                        onChange={this.handleChangeText}
                        readOnly
                      /> 
                    </Col>

                    <Col md="6">
                    <label>Lieu</label>
                      <Input
                        className="form-control"
                        type="text"
                        id="lieu"
                        onChange={this.handleChangeText}
                        readOnly
                      /> 
                    </Col>
                  </Row>

                  <Row className="mt-4"> 
                    <Col md="12">
                    <label>Objectif</label>
                     
                      <textarea
                        className="form-control"
                        onChange={this.handleChangeText}
                        id="objectif"
                     
                        readOnly
                      />
                    </Col>
                  </Row>

                  <Row className="mt-4"> 
                    <Col md="12" > 
                     <label>Description </label>
                    
                      <textarea   onChange={this.handleChangeText} className="form-control"   id="description" readOnly/>
                    </Col>
                  </Row>

                  
                  <Row className="mt-4">
                      <Col md="6">
                        <div id="ddd" >
                        <label>Date de début</label>
                          
                          <Input
                              className="form-control owener-close"
                              type="text"
                              id="date_debut"
                            
                              readOnly
                          />
                        </div>

                        <div className="docs-datepicker show" 
                          data-toggle="tooltip" 
                          data-placement="top" 
                          data-html="true"
                          title="Date de début de l'évènement"
                          id="debut"
                        >
                        <InputGroup>
                          <Flatpickr
                            value={pick}
                            className="form-control d-block "
                            aria-label="Default select example"
                            placeholder="Choisissez la date de début de l évènement"
                            // id="datePub"
                            
                            options={{
                              locale:French,
                              // mode: "range",
                              minDate:today,
                              altInput: true,
                              // enableTime: true,
                              // altFormat: "F j, Y",
                              altFormat: "d/M/Y"
                            }}
                             onChange={e=>this.setState({date_debut:e[0],validate_update:true})}
                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-outline-secondary docs-datepicker-trigger"
                              disabled
                            >
                              <i
                                className="fa fa-calendar"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </InputGroup>
                        <div className="docs-datepicker-container" />
                        </div>
                      </Col>


                    <Col md="6">
                        <div id="ddf" >
                          <label >Date de fin</label>
                       
                          <Input
                              className="form-control owener-close"
                              type="text"
                              id="date_fin"
                             
                              readOnly
                          />
                    
                      </div>

                      <div className="docs-datepicker show" 
                        data-toggle="tooltip" 
                        data-placement="top" 
                        data-html="true"
                        title="Date de fin de l'évènement"
                        id="fin"
                      >
                        <InputGroup>
                          <Flatpickr
                            value={pick}
                            className="form-control d-block "
                            aria-label="Default select example"
                            placeholder="Choisissez la date de fin de l évènement"
                            // id="datePub"
                            
                            options={{
                              locale:French,
                              // mode: "range",
                              minDate:today,
                              altInput: true,
                              // enableTime: true,
                              // altFormat: "F j, Y",
                              altFormat: "d/M/Y"
                            }}
                            onChange={e=>this.setState({date_fin:e[0],validate_update:true})}
                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-outline-secondary docs-datepicker-trigger"
                              disabled
                            >
                              <i
                                className="fa fa-calendar"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </InputGroup>
                        <div className="docs-datepicker-container" />
                      </div>



                    </Col>
                  </Row>


                  <Row className="mt-4"> 
                    {/* <Col md="4"></Col> */}
                    <Col md="6">
                      <label>Heure de début de l'évènement</label>

                      <Input
                          className="form-control owener-close"
                          type="text"
                          id="h_debut"
                        
                          readOnly
                      />
                        
                      <div className="docs-datepicker show" id="heure_debut">
                        <InputGroup>
                          <Flatpickr
                            className="form-control d-block"
                            placeholder="heure de debut"
                            options={{
                              locale:French,
                              enableTime: true,
                              noCalendar: true,
                              dateFormat: "H:i",
                              //defaultDate: "13:45"
                            }}
                            onChange={e=>this.setState({heureDebut:format(e[0],'HH:mm'),validate_update:true})}

                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-outline-secondary docs-datepicker-trigger"
                              disabled
                            >
                              <i
                                className="fa fa-clock"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </InputGroup>
                        <div className="docs-datepicker-container" />
                      </div>
                    </Col>

                    <Col md="6">
                      <label>Heure de fin de l'évènement</label>
                      <Input
                          className="form-control owener-close"
                          type="text"
                          id="h_fin"
                        
                          readOnly
                      />
                      <div className="docs-datepicker show" id="heure_fin">
                        <InputGroup>
                          <Flatpickr
                            className="form-control d-block"
                            placeholder="heure de fin"
                            options={{
                              locale:French,
                              enableTime: true,
                              noCalendar: true,
                              dateFormat: "H:i",
                              //defaultDate: "13:45"
                            }}
                            onChange={e=>this.setState({heureFin:format(e[0],'HH:mm'),validate_update:true})}

                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-outline-secondary docs-datepicker-trigger"
                              disabled
                            >
                              <i
                                className="fa fa-clock"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </InputGroup>
                        <div className="docs-datepicker-container" />
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-4"> 
                    <Col md="12"> 
                    <label >Url</label>
                     
                        <Input
                            className="form-control"
                            type="text"
                            id="url"
                            onChange={this.handleChangeText}
                            readOnly
                        /> 
                    </Col>
                  </Row>
                  </CardBody>
                </Card>


                <hr/>
                  <h4 className="text-center mt-2">Catégorisation de l'évènement</h4>
                <hr/>


                <Row className="mb-4">
                    

                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle className="mb-4 h4e">Pays(s)</CardTitle>

                      
                        <div id="localisation" className="show mt-4">
                            <ReactSelect
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti
                                   onChange={this.handleCheckLocalisation}
                                   options={this.state.localisations}
                                placeholder="Choisir la/les pays(s)"
                            />
                        </div>
                        <div className=" mt-4">
                          {
                            this.state.localite.length?
                            <table className="table align-middle">
                            <thead>
                                    <tr>

                                        <th>Code(s) du/des pays(s)</th> <th>Pays(s)</th> <th  style={{display:this.state.hide}}>Action</th> 

                                    </tr>
                                </thead>
                                <tbody>
                                    
                                {
                                
                                (this.state.localite.map(
                                    (element,idx)=>(
                                    <tr>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">{element.code}</p>
                                        </td>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">{element.nom}</p>
                                        </td>
                                        <td style={{ width: "30%" }}>
                                            <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteLocalisation.bind(this,element.id)}><strong>X</strong></a>
                                        </td>
                                    </tr>
                                    )))
                                }
                                </tbody>
                            </table>:
                            (<span>Aucun pays associé.</span>)
                            }
                            </div>
                        </CardBody>
                        </Card>
                    </Col>
                    
                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                          <CardTitle className="mb-4 h4">Unité(s) administrative(s)</CardTitle>
                        

                          
                            <div id="uniteadministrative" className="show mt-4">
                             {
                              this.state.unites.length?
                                  <ReactSelect
                                      closeMenuOnSelect={false}
                                      components={animatedComponents}
                                      isMulti
                                      onChange={this.handleCheckUnite}
                                      options={this.state.unites}
                                      placeholder="Choisir la/les unité(s) administrative(s)"
                                  />:null
                               }
                          </div>

                          <div className=" mt-4">
                          {   
                           (this.state.unite.length!=0)?
                            <table className="table align-middle">

                            <thead>
                                    <tr>
                                        <th>Libelle</th> <th>Code</th> {this.state.unite ?<th  style={{display:this.state.hide}}>Action</th>:null}
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                {
                                
                                (this.state.unite.map(
                                    (element,idx)=>(
                                    <tr>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">{element.libelle}</p>
                                        </td>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">{element.code}</p>
                                        </td>
                                        <td style={{ width: "30%" }}>
                                            <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteUnite.bind(this,element.id)} ><strong>X</strong></a>
                                        </td>
                                    </tr>
                                    )))

                                

                                } 

                                </tbody>
                            </table>:
                            (<span>Aucune unité administrative associée.</span>)
                             }
                            </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Row>
                <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                         <CardTitle className="mb-4 h4">Thématique(s)</CardTitle>
                          <div id="thematique" className="show mt-4">
                              <ReactSelect
                                  closeMenuOnSelect={false}
                                  components={animatedComponents}
                                  isMulti
                                  onChange={this.handleCheckThematique}
                                  options={this.state.thematiques}
                                  placeholder="Choisir la/les thématique(s)"
                              />
                          </div>

                          <div className=" mt-4">
                            <table className="table align-middle">

                            {/* <thead>
                                    <tr>
                                        <th>Libelle</th>
                                    </tr>
                                </thead> */}
                                <tbody>
                                   
                                {
                                    (this.state.thematique.length!=0)?
                                    (this.state.thematique.map(
                                        (element,idx)=>(
                                        <tr>
                                            <td style={{ width: "30%" }}>
                                                <p className="mb-0">{element.libelle}</p>
                                            </td>
                                            <td style={{ width: "30%" }}>
                                                <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteThematique.bind(this,element.id)} ><strong>X</strong></a>
                                            </td>
                                        </tr>
                                        )
                                       )
                                    ):(  <tr>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">Aucune thématique associée.</p>
                                        </td>
                                        
                                    </tr>)

                                    } 
                                </tbody>
                            </table>
                            </div>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                          <CardTitle className="mb-4 h4">Type(s) de système(s) irrigué(s)</CardTitle>
                         
                          <div id="typesystemeirrigation" className="show mt-4">
                              <ReactSelect
                                  closeMenuOnSelect={false}
                                  components={animatedComponents}
                                  isMulti
                                  onChange={this.handleCheckSysteme}
                                  options={this.state.irrigues}
                                  placeholder="Choisir la/les type(s) de système(s) irrigué(s)"
                              />
                          </div>
                          <div className=" mt-4">
                          {
                            this.state.systeme.length?
                            <table className="table align-middle">
                                <thead>
                                    <tr>
                                        <th>Libelle</th> <th>Sigle</th> {this.state.systeme.length?<th style={{display:this.state.hide}}>Action</th>:null}
                                    </tr>
                                </thead>
                                <tbody>
                                    {

                                        (this.state.systeme.map(
                                            (element,idx)=>(
                                             <tr>
                                                <td style={{ width: "30%" }}>
                                                    <p className="mb-0">{element.libelle}</p>
                                                </td>
                                                <td style={{ width: "30%" }}>
                                                    <p className="mb-0">{element.sigle}</p>
                                                </td>
                                                <td style={{ width: "30%" }}>
                                                    <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteSysteme.bind(this,element.id)} ><strong>X</strong></a>
                                                </td>
                                            </tr>
                                            )

                                        ))

                                    }                              

                                </tbody>
                            </table>:
                            (<span>Aucun système d'irrigation associé.</span>)
                            }
                            </div>
                        </CardBody>
                        </Card>
                    </Col>
                    

                    
                </Row>

                <Row>
                  <Col md="6">
                      <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                      <CardBody>
                      <CardTitle  className="mb-4 h4 ">Langue(s)</CardTitle>
                      
                      <div id="langue" className="show mt-4">
                          <ReactSelect
                              closeMenuOnSelect={false}
                              components={animatedComponents}
                              isMulti
                              onChange={this.handleCheckLangue}
                              options={this.state.langues}
                              placeholder="Choisir la/les langue(s)"
                          />
                      </div>
                      <div className=" mt-4">
                          <table className="table align-middle">
                              <tbody>
                              
                              {
                                        (this.state.langue.length!=0) ?
                                        (this.state.langue.map(
                                            (element,idx)=>(
                                                <tr>
                                                <td style={{ width: "30%" }}>
                                                    <p className="mb-0">{element.nom}</p>
                                                </td>
                                                <td style={{display:this.state.hide,width: "30%"}} className="owener2">
                                                    <a style={{display:this.state.hide}} className="owener"  onClick={this.handleDeleteLangue.bind(this,element.id)} ><strong>X</strong></a>
                                                </td>
                                            </tr>
                                            )

                                        )):(  <tr>
                                            <td style={{ width: "30%" }}>
                                                <p className="mb-0">Aucune langue associée.</p>
                                            </td>
                                            
                                        </tr>)

                                        } 

                              </tbody>
                          </table>
                          </div>
                      </CardBody>
                      </Card>
                    </Col>




                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle className="mb-4 h4">Mot(s) clé(s)</CardTitle>
                       
                        <div id="motcle" className="show mt-4">
                          <CreatableSelect
                            closeMenuOnSelect={false}
                            components={{Menu}}
                            isMulti
                            onChange={this.handleChangeMotCle}
                            isValidNewOption={isValidNewOption}
                            options={this.state.motcle}
                            placeholder="Choisir la/les mot(s) clé(s)"
                          />
                        </div>
                        <div className=" mt-4">
                            <table className="table align-middle">

                            <thead>
                                </thead>
                                <tbody>
                                  
                                {
                                    (this.state.mot.length!=0)?
                                   
                                    (this.state.mot.map(
                                        (element,idx)=>(
                                            <tr>
                                            <td style={{ width: "30%" }}>
                                                <p className="mb-0">{element.libelle}</p>
                                            </td>
                                            <td style={{ width: "30%" }}>
                                                <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteMotCle.bind(this,element.id)} ><strong>X</strong></a>
                                            </td>
                                        </tr>
                                        )

                                    )):(  <tr>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">Aucun mot-clé associé.</p>
                                        </td>
                                        
                                    </tr>)

                                    } 

                                </tbody>
                            </table>
                            </div>
                            </CardBody>
                        </Card>
                    </Col>




                  <Col md="6">
                    <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                    <CardBody>
                    <CardTitle className="mb-4 h4">Type(s) d'accès</CardTitle>
                        
                        <div id="profile" className="show mt-4">
                          <Row className="mt-4"> 
                          {
                              !this.state.acces.filter(x => (x.libelle).toLowerCase() === ("Public").toLowerCase()).length?
                            <Col md="6">
                              
                              <label>Choisissez le type d'accès</label>
                              <select className="form-select" onChange={this.handleChangeAcces} aria-label="Default select example" id="acces">
                                {/* <option selected>Choisir le type d'accès</option> */}
                                <option selected value="Public">Public</option>
                                <option value="Privé">Privé</option>
                              </select>
                             
                            </Col>:null
                             } 
                            <Col md="6" >
                              <div id="profiles" style={{display:this.state.acces.filter(x => (x.libelle).toLowerCase() === ("Public").toLowerCase()).length?"block":"none"}}>
                              <label>Profil(s)</label>
                              <ReactSelect
                                  closeMenuOnSelect={false}
                                  components={animatedComponents}
                                  isMulti
                                  options={this.state.profile}
                                  placeholder="Choisir le/les profil(s)"
                                  onChange={this.handleChangeProfile} 
                                  aria-label="Default select example" 
                                  id="profile_id"
                                />
                            
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <div className=" mt-4">
                            <table className="table align-middle">

                            <thead>
                                   
                                </thead>
                                <tbody>
                                  
                                {
                                    (this.state.acces.length!=0)?
                                   
                                    (this.state.acces.map(
                                        (element,idx)=>(
                                            <tr>
                                            <td style={{ width: "30%" }}>
                                                <p className="mb-0">{element.libelle}</p>
                                            </td>
                                            <td style={{ width: "30%" }}>
                                                <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteProfile.bind(this,element.id)} ><strong>X</strong></a>
                                            </td>
                                        </tr>
                                        )

                                    )):(  <tr>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">Aucun profil associé.</p>
                                        </td>
                                        
                                    </tr>)

                                    } 

                                </tbody>
                            </table>
                            </div>
                            </CardBody>
                        </Card>
                    </Col>
                    
                </Row>
                
                {this.state.validate_update?
                <Row>
                  <Col md="6">
                    <Button onClick={this.handleAnuler} style={{backgroundColor:"#6A7172",float:"left",borderRadius:"10px"}} >
                      Annuler
                    </Button>
                  </Col>
                  <Col md="6" >
                  
                    
                    {
                    this.state.chargement_data?
                    <Button id="chargement" style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
                          Envoi...
                    </Button>:
                    <Button id="initial" onClick={this.handleModifierEvenement} style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                       Appliquer la modification
                    </Button>
                    }
                    
                  </Col>
                </Row>:null
                  }

                <hr></hr>
                

                
              </Container>
              </div>
                  </>):(
                    <div style={{marginTop:"250px",textAlign:"center"}}>
                       <Spinner type="grow" color="secondary" />
                </div>
                )
                
              }
          </React.Fragment>
        )}
  }
  export default DetailEvenement